// import { observable } from "mobx";
export class StakeButtonsStatusesModel {
    constructor(source) {
        this.plusEnabled = source.plusEnabled;
        this.minusEnabled = source.minusEnabled;
    }
}
//# sourceMappingURL=StakeButtonsStatusesModel.js.map